// src/services/api/CharactersApiService.ts
import BaseApiService from './BaseApiService';
import { ICharacterDto } from '../../shared/interfaces';
import Papa from 'papaparse';

class CharactersApiService extends BaseApiService {
    constructor() {
        super('api');
    }

    public async getCharacters(): Promise<ICharacterDto[]> {
        return this.GET<ICharacterDto[]>('characters/fullset');
    }

    public async getCharacterCSV(characterId: number, level: string): Promise<any[]> {
        return this.GET<any[]>(`${characterId}/csv`, { params: { level } });
    }

    public async getCharacterGesture(characterId: number, level: string): Promise<any[]> {
        return this.GET<any[]>(`${characterId}/gesture`, { params: { level } });
    }

    public async getCharacterStat(characterId: number, level: string): Promise<any> {
        return this.GET<any>(`${characterId}/stat`, { params: { level } });
    }

    public async createCharacter(data: {
        accountName: string;
        characterName: string;
        race: string;
        aspect: string;
        gender: string;
        'custom:portrait': string;
    }): Promise<ICharacterDto> {
        return this.POST<ICharacterDto>('character/create', data, {
            headers: { 'Content-Type': 'application/json' },
        });
    }

    public async postTask(files: File[]): Promise<any> {
        const formData = new FormData();
        files.forEach(file => formData.append('files', file));
        return this.POST<any>('task', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    }

    public async getCharacterFilesByDate(characterId: number, date: string): Promise<any> {
        return this.GET<any>(`characters/${characterId}/files`, { params: { date } });
    }

    public async getCharacterCSVData(
        characterId: number,
        date: string,
        type: 'raw' | 'processed' = 'processed'
    ): Promise<any[]> {
        const response = await this.GET<string>(`characters/${characterId}/csv`, {
            params: { date, type },
            responseType: 'text',
        });
        const parsed = Papa.parse(response.replace(/^\uFEFF/, ''), { header: true, skipEmptyLines: true });
        return parsed.data as any[];
    }

    /** 🔹 Новый обработанный метод с поддержкой recordID */
    public async getCharacterCSVByLevel(
        characterId: number,
        date: string,
        level?: string,
        typeEx?: string,
        createdAt?: string,
        fileType: 'raw' | 'processed' = 'processed',
        recordID?: string
    ): Promise<any[]> {
        const token = localStorage.getItem('authToken');
        console.log('🔹 JWT token:', token);

        try {
            if (recordID) {
                console.log(`🔹 Fetching CSV for character ${characterId} with recordID ${recordID}`);

                const headers = { Authorization: `Bearer ${token}` };
                console.log('🔹 Request headers:', headers);

                const response = await this.GET<string>(`characters/${characterId}/csv/record/${recordID}`, {
                    responseType: 'text',
                    headers,
                });

                console.log('🔹 CSV raw string length:', response?.length ?? 0);
                console.log('🔹 CSV raw preview (first 200 chars):', response?.slice(0, 200));

                const csvClean = response.replace(/^\uFEFF/, ''); // BOM
                const parsed = Papa.parse(csvClean, {
                    header: true,
                    skipEmptyLines: true,
                    delimiter: ';'
                });

                console.log('🔹 Parsed CSV rows count:', parsed.data.length);
                return parsed.data as any[];
            }

            // Старый способ по дате/уровню
            console.log(`🔹 Fetching CSV by date: ${date}, level: ${level}`);
            const response = await this.GET<any>(`characters/${characterId}/csv`, {
                params: { date, level, typeEx, createdAt, type: fileType },
                headers: { Authorization: `Bearer ${token}` },
            });

            console.log('🔹 Old CSV fetch response:', response);
            return [];
        } catch (err) {
            console.error('❌ Error in getCharacterCSVByLevel:', err);
            return [];
        }
    }
    /** 🔹 Получить завершённые квесты по персонажу и дате */
    public async getCompletedQuests(characterId: number, date: string): Promise<any[]> {
        const token = localStorage.getItem('authToken');
        if (!token) throw new Error('JWT токен отсутствует');

        try {
            const response = await this.GET<any>(`quests/completed`, {
                params: { characterId, date },
                headers: { Authorization: `Bearer ${token}` },
            });

            console.log('🔹 Completed quests received:', response);

            return response?.tasks || []; // бекенд возвращает { success: true, tasks: [...] }
        } catch (err) {
            console.error('Ошибка при загрузке завершённых квестов:', err);
            return [];
        }
    }
}

export default new CharactersApiService();
